export default {"src":"/_next/static/media/Oklahoma.52486089.svg","height":316,"width":800,"blurWidth":0,"blurHeight":0};